import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import Verification from 'components/common/Verification/Verification';
import VerifyNumberSubmit from 'components/common/VerifyNumber/VerifyNumberSubmit';
import AxiosRequest from 'api/AxiosRequest';
import ErrorAlert from 'components/common/ErrorAlert';

const LegacyMigrateDialog = ({ open, userData, updateUserData, closeDialog }) => {
    const [activeStep, setActiveStep] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [errorCode, setErrorCode] = useState(null);
    
    const UpdateVerifiedNumber = (receipt) => {
        const data = {
            "verification_receipt": receipt
        };

        AxiosRequest("Account/" + userData.sid + "/phone-number", data).then(() => {
        })
        .catch(error => {
            console.log(error);
            if (error && error.response) {
                if (error.response.status && error.response.status >= 500) {
                    setErrorMessage("There was an error. Please try again.");        
                } else if (error.response.data.error) {
                    setErrorMessage(error.response.data.error.message);
                    setErrorCode(error.response.data.error.code);
                } else {
                    setErrorMessage("There was an error. Please try again.");
                }
            }
        });
    }

    return (
        <Dialog open={open} id="LegacyMigrateDialog">
            {activeStep && activeStep === 1 &&
            <DialogTitle className='legacy-migrate-title'><ErrorIcon /> Verify your number</DialogTitle>
            }
            <DialogContent>
                {activeStep && activeStep === 1 &&
                <>
                <p>All accounts must have a verified phone number to log in with in order to continue using 
                    SpoofCard. Verify your number now to avoid any interruption of service.</p>
                <p>This number will be the primary number on your account and will be the number you use 
                to log in moving forward.</p>
                </>
                }
                {/* {userData && userData.phone_number_verified &&
                <Verification scope={"accounts.phone_number.update"} getActiveStep={setActiveStep} callBack={UpdateVerifiedNumber} />
                } */}
                {userData && !userData.phone_number_verified &&
                <Verification scope={"accounts.phone_number.update"} getActiveStep={setActiveStep} callBack={UpdateVerifiedNumber}
                    comp={<VerifyNumberSubmit closeDialog={closeDialog} userData={userData} updateUserData={updateUserData} />} />
                }
                {errorMessage &&
                <ErrorAlert message={errorMessage} code={errorCode} />
                }
            </DialogContent>
        </Dialog>
    );
};

export default LegacyMigrateDialog;
